import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n                  & > * + * {\n                      margin-left: 18px;\n                  }\n              "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    border-top: 1px solid ", ";\n    margin: 16px 20px 20px;\n    padding-top: 20px;\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
var StyledDialogActions = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.gray.gray200;
}, function (_ref2) {
  var disableSpacing = _ref2.disableSpacing;
  return !disableSpacing ? css(_templateObject2()) : null;
});
export function DialogActions(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledDialogActions, Object.assign({}, props), children);
}